// Services/fetchGetOrdersByRestaurant.js
import { ORDERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

// Reemplaza {restauranteId} en el template
const pathWithParams = (template, params) =>
  template.replace(/\{(\w+)\}/g, (_, key) => encodeURIComponent(params[key] ?? ""));

export const fetchOrdersByRestaurant = async (restauranteId) => {
  if (!restauranteId) {
    return { statusCode: 400, message: "restauranteId es requerido" };
  }

  // Checa token solo para dar mejor mensaje (el interceptor igual lo inyecta)
  try {
    const raw = localStorage.getItem("logindata");
    const token = raw ? JSON.parse(raw)?.data?.token : null;
    if (!token) return { statusCode: 401, message: "No autenticado. Inicia sesión" };
  } catch {}

  // Construye la ruta desde tu constante con placeholder
  const path = pathWithParams(ORDERS.getOrdersByRestaurant, { restauranteId });

  // Evita 304 del navegador
  const pathNoCache = `${path}?_t=${Date.now()}`;

  // Firma: ApiRequestInterceptor(path, method, body, headers)
  // No pasamos Authorization aquí para evitar headers duplicados; el interceptor ya lo agrega desde localStorage
  const res = await ApiRequestInterceptor(pathNoCache, "GET", null);

  if (res?.code === 200) {
    const items = res?.data?.items ?? [];
    const count = res?.data?.count ?? items.length;
    return { statusCode: 200, items, count };
  }
  if (res?.code === 401) return { statusCode: 401, message: res?.data?.message || "Token inválido o expirado" };
  if (res?.code === 403) return { statusCode: 403, message: res?.data?.message || "No autorizado" };

  return {
    statusCode: res?.code || 500,
    message: res?.data?.message || "Error al obtener pedidos",
  };
};